import { format, parse, parseISO, isValid } from "date-fns";

export const setFormValues = (schema, setValue) => {
  for (const key in schema) {
    setValue(key, schema[key]);
  }
};

export const setAllFormValues = (obj, setValue, format_dates = false) => {
  const isValidDate = (value) => {
    if (!value || isNaN(value) === false) return false;

    const valueStr = value.toString();

    // Try ISO 8601
    const isoDate = parseISO(valueStr);
    if (isValid(isoDate)) return true;

    // Try common formats
    const formats = ["yyyy-MM-dd", "MM/dd/yyyy", "dd-MM-yyyy"];
    return formats.some((formatStr) => {
      const parsed = parse(valueStr, formatStr, new Date());
      return isValid(parsed);
    });
  };

  Object.entries(obj).forEach(([name, value]) => {
    const is_date = format_dates && isValidDate(value) && isNaN(value);
    if (is_date) {
      try {
        // Try to parse and format the date
        const parsed =
          parseISO(value.toString()) ||
          parse(value.toString(), "dd/MM/yyyy", new Date());
        setValue(name, isValid(parsed) ? format(parsed, "yyyy-MM-dd") : value);
      } catch {
        setValue(name, value);
      }
    } else {
      setValue(name, value);
    }
  });
};
